const JobsAPI = {

  create(data) {
    return $cfg.API.post('/admin/jobs', data);
  },

  selectAll() {
    return $cfg.API.get('/admin/jobs/all');
  },

  remove(job_id) {
    return $cfg.API.delete('/admin/jobs/' + job_id);
  },

  update(job_id, data) {
    return $cfg.API.put('/admin/jobs/' + job_id, data);
  },
}

export { JobsAPI }
